import { z } from 'zod';
import { CustomKeyTypesEnum } from '../../../profile-api-client';
import { DeepRequired } from '../../../utils';
import { RedocSchemaObject, extendApi } from '../../openapi';
import { uuid } from '../../utils';

export const publicCustomAttribute = extendApi(
  z.object({
    id: uuid,
    label: extendApi(z.string(), {
      description: 'Name displayed in the Manager',
      example: 'Subscribed to our newsletter?',
    }),
    technicalKey: extendApi(z.string().min(1), {
      description: 'Key used in the API',
      example: 'newsletter_subscribed',
    }),
    type: extendApi(z.nativeEnum(CustomKeyTypesEnum), {
      description: 'Type of the custom attribute',
      example: CustomKeyTypesEnum.BOOLEAN,
    }),
  }),
  {
    description:
      'Custom attributes for the member that your SSO can provide to Qualifio Rewards Program',
  },
);

export const publicCustomAttributeRef = extendApi(publicCustomAttribute, {
  $ref: '#/components/schemas/CustomAttribute',
} as RedocSchemaObject);

export type PublicCustomAttribute = DeepRequired<z.infer<typeof publicCustomAttribute>>;
